// src/components/Fields/AttachFilePreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DraggablePreviewWrapper from './DraggablePreviewWrapper';
import { useFormLayout } from '../../contexts/FormLayoutContext';

const AttachFilePreview = ({ id, index }) => {
  const { showDropZones, setShowDropZones } = useFormLayout();

  return (
    <DraggablePreviewWrapper
      id={id}
      type="attach"
      index={index}
      isNew={true}
      showDropZones={showDropZones}
      setShowDropZones={setShowDropZones}
    >
      <Box display="flex" alignItems="center">
        <AttachFileIcon sx={{ fontSize: '0.95rem', mr: 1, color: '#455A64' }} />
        <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
          Attach File
        </Typography>
      </Box>
    </DraggablePreviewWrapper>
  );
};

export default AttachFilePreview;
